import React, { useState } from 'react';
import { FaUserCheck } from 'react-icons/fa';
import { MdKeyboardArrowDown } from 'react-icons/md';

import { CircularProgress } from '@material-ui/core';

import Button from '~/components/Button';
import Modal from '~/components/Modal';

import { MultipleActionOption } from '../../interface';
import {
  ButtonContainer,
  ButtonIcons,
  SelectManyContainer,
  ModalContainer,
  LoadingContainer,
} from './styles';

interface TableButtonProps {
  multipleActionOption?: MultipleActionOption[];
  disableMultSelectButton?: boolean;
  loadingMultSelectButton?: boolean;
}

const TableMultSelectButton: React.FC<TableButtonProps> = ({
  multipleActionOption,
  disableMultSelectButton,
  loadingMultSelectButton,
}) => {
  const [modalSelectMany, setModalSelectMany] = useState<boolean>(false);

  return (
    <>
      <ButtonContainer>
        <Button
          variant="outline"
          onClick={() => setModalSelectMany(true)}
          disabled={loadingMultSelectButton ? true : disableMultSelectButton}
        >
          {loadingMultSelectButton ? (
            <LoadingContainer>
              <CircularProgress size={20} color="inherit" />
            </LoadingContainer>
          ) : (
            <ButtonIcons>
              <FaUserCheck size={20} />
              <MdKeyboardArrowDown size={20} />
            </ButtonIcons>
          )}
        </Button>
      </ButtonContainer>

      {modalSelectMany && (
        <ModalContainer>
          <Modal
            title="Selecione a ação em massa"
            open={modalSelectMany}
            modalState={(opened) => setModalSelectMany(opened)}
            size="xs"
          >
            <SelectManyContainer>
              {multipleActionOption?.map((actionOption) => (
                <div>
                  {actionOption.icon}
                  <button
                    type="button"
                    onClick={() => {
                      actionOption.action();
                      setModalSelectMany(false);
                    }}
                  >
                    {actionOption.label}
                  </button>
                </div>
              ))}
            </SelectManyContainer>
          </Modal>
        </ModalContainer>
      )}
    </>
  );
};

export default TableMultSelectButton;
